'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidPlane = function IoAndroidPlane(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 26.3l-12.5-3.8v8.9l3.8 2.4v2.4l-6.3-1.2-6.2 1.3v-2.5l3.7-2.4v-8.9l-12.5 3.8v-3.2l12.5-8.1v-8.8c0-1.4 1.2-2.5 2.5-2.5s2.5 1.1 2.5 2.5v8.8l12.5 8.1v3.2z' })
        )
    );
};

exports.default = IoAndroidPlane;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-plane.js
// module id = 2376
// module chunks = 168707334958949